export default __webpack_public_path__ + "static/media/Logo-big.2ffed9f6.png";